import React, { Component } from 'react';
import { Autocomplete, Box, Button, Checkbox, Drawer, IconButton, Stack, TextField, Tooltip, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { withTranslation } from 'react-i18next';
import '../../FrontOffice/FOReports/reports.css';
import { ImagePaths } from '../../../Utility/ImagePaths';
import CommonDatePicker from '../../../Components/Common Components/CommonDatePicker';
import { CommonGridToolBarWithFilterText, CommonPatientDetails } from "../../../Components/Common Components/CommonComponents";
import CommonValidation from '../../../Components/CommonFunctions/CommonValidation';
import ToastMsg from '../../../Components/ToastMsg/ToastMsg';
import RestAPIService from '../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../Utility/API/Serviceurls';
import { DateTime } from 'luxon';
import { splitDate, AmountFormat, formatDate } from '../../../Components/CommonFunctions/CommonFunctions';
import { localGetItem, localSetItem } from '../../../Utility/Services/CacheProviderService';
import { AmountsCard } from '../../../Components/CommonCards/CommonCards';
import Loader from '../../../Components/Loader';
import { CurrencySymbol } from '../../../Utility/Constants';

class AdvanceAdded extends Component {

    constructor(props) {
        super(props)
        const savedFilter = JSON.parse(localGetItem('globalDateFilter') || 'null');
        this.state = {
            page: 0,
            pageSize: 10,
            fromDate: savedFilter?.FromDate || DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
            toDate: savedFilter?.ToDate || DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
            dateIndex: savedFilter?.DateIndex || 1,
            advanceAddedData: [],
            total_net_amount: 0,
            patient_name: "",
            uhid: "",
            mobile_number: '',
            ip_number: '',
            invoice_number: '',
            printLoading: false,
            disableBtn: false,
        }
    }

    componentDidMount() {
        this.getAdvanceAddedData()
    }

    errorMessage = (message) => {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: message
        })
    }

    msgClose() {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
        })
    }

    FilterDate = (from, to, index) => {
        this.setState({
            fromDate: from,
            toDate: to,
            dateIndex: index
        })
    }

    LoaderFunction = (key) => {
        this.setState({
            isLoader: key
        })
    }

    getAdvanceAddedData = () => {
        try {
            const baseUrl = Serviceurls.GET_ADVANCE_ADDED;
            RestAPIService.getAll(`${baseUrl}?from_date=${this.state.fromDate}&to_date=${this.state.toDate}&patient_name=${this.state.patient_name}&ip_number=${this.state.ip_number}&invoice_number=${this.state.invoice_number}&uhid=${this.state.uhid}&mobile_number=${this.state.mobile_number}`)
                .then((response) => {
                    if (response.data.status === "success") {
                        this.LoaderFunction(false);
                        let list = response.data?.data?.length > 0 ? response.data?.data : [];
                        list.forEach((item, index) => {
                            item["sno"] = index + 1
                        })
                        this.setState({
                            advanceAddedData: list,
                            total_net_amount: response?.data?.total_amount,
                        })
                    }
                }).catch((error) => {
                    if (error?.response?.data?.status === 'fail') {
                        this.LoaderFunction(false);
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.LoaderFunction(false);
                        this.errorMessage(error.message)
                    }
                })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    exportReport = () => {
        try {
            this.setState({ disableBtn: true })
            const baseUrl = Serviceurls.GET_ADVANCE_ADDED;
            RestAPIService.excelGet(`${baseUrl}?from_date=${this.state.fromDate}&to_date=${this.state.toDate}&patient_name=${this.state.patient_name}&ip_number=${this.state.ip_number}&invoice_number=${this.state.invoice_number}&uhid=${this.state.uhid}&mobile_number=${this.state.mobile_number}&export_type=excel`)
                .then((response) => {
                    if (response.data) {
                        var pom = document.createElement('a');
                        var csvContent = response?.data; //here we load our csv data 

                        let filename = response?.headers["content-disposition"]?.split("filename=")[1]

                        var blob = new Blob([csvContent], { type: 'application/x-www-form-urlencoded; charset=UTF-8' }); // text/csv;charset=utf-8;
                        var url = URL.createObjectURL(blob);
                        pom.href = url;
                        pom.setAttribute('download', filename ? filename : 'registry.xlsx');
                        pom.click();
                        this.setState({ disableBtn: false })
                    }
                }).catch((error) => {
                    if (error?.response?.data?.status === "fail") {
                        this.errorMessage(error?.response?.data?.message)
                    } else {
                        this.errorMessage(error?.message)
                    }
                    this.setState({ disableBtn: false })
                })
        } catch (e) {
            this.errorMessage(e?.message)
            this.setState({ disableBtn: false })
        }
    }

    renderFilterScreen = () => {
        const { t } = this.props
        return (
            <Box component={"div"} className='eMed_rts_filter_container'>
                <Box component={"div"} className='eMed_filter_Top'>
                    <Typography variant='h6' fontWeight={600}>{t("Filter")}</Typography>
                    <Button emed_tid={'filter_btn'} onClick={() => { this.setState({ FilterOpen: false }) }} className='eMed_usrconf_btn'>
                        <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                    </Button>
                </Box>
                <Box className='eMed_rts_middle' overflow={'auto'}>
                    <Box className='eMed_date_filter'>
                        <CommonDatePicker
                            FromDate={this.state.fromDate}
                            ToDate={this.state.toDate}
                            emed_tid={"FilterDate_TestID01"}
                            DateIndex={this.state.dateIndex}
                            SelectedDates={this.FilterDate.bind(this)}
                            HideAllMenu={true} />
                    </Box>
                    <Box className='eMed_rts_dropdown'>
                        <TextField
                            sx={{ width: "20vw" }}
                            inputProps={{ maxLength: 20, emed_tid: 'patient_name' }}
                            size='small'
                            label={t("Patient Name")}
                            value={this.state.patient_name}
                            autoComplete='off'
                            emed_tid={"patient_nameTestID01"}
                            onChange={(e) => {
                                let alpha = CommonValidation.alphabetOnly(e.target.value);
                                if (alpha || e.target.value === "") {
                                    this.setState({ patient_name: e.target.value })
                                }
                            }}
                        />
                    </Box>
                    <Box className='eMed_rts_dropdown'>
                        <TextField
                            sx={{ width: "20vw" }}
                            inputProps={{ maxLength: 20, emed_tid: 'UHID' }}
                            size='small'
                            label={t("UHID")}
                            value={this.state.uhid ? this.state.uhid : ""}
                            autoComplete='off'
                            emed_tid={"UHIDTestID01"}
                            onChange={(e) => {
                                let number = CommonValidation.ALPHA_NUM_SPLCHAR(e.target.value);
                                if (number || e.target.value === "") {
                                    this.setState({ uhid: e.target.value })
                                }
                            }}
                        />
                    </Box>
                    <Box className='eMed_rts_dropdown'>
                        <TextField
                            sx={{ width: "20vw" }}
                            inputProps={{ maxLength: 20, emed_tid: 'mobile_number' }}
                            size='small'
                            label={t("Mobile")}
                            value={this.state.mobile_number ? this.state.mobile_number : ""}
                            autoComplete='off'
                            emed_tid={"mobile_numberTestID01"}
                            onChange={(e) => {
                                let number = CommonValidation.numberOnly(e.target.value);
                                if ((number && e.target.value?.length <= 10) || e.target.value === "") {
                                    this.setState({ mobile_number: e.target.value })
                                }
                            }}
                        />
                    </Box>
                    <Box className='eMed_rts_dropdown'>
                        <TextField
                            sx={{ width: "20vw" }}
                            inputProps={{ maxLength: 20, emed_tid: 'invoice_number' }}
                            size='small'
                            label={t("Return Bill Number")}
                            value={this.state.invoice_number}
                            autoComplete='off'
                            emed_tid={"invoice_numberTestID01"}
                            onChange={(e) => {
                                let number = CommonValidation.ALPHA_NUM_SPLCHAR(e.target.value);
                                if (number || e.target.value === "") {
                                    this.setState({ invoice_number: e.target.value })
                                }
                            }}
                        />
                    </Box>
                    <Box className='eMed_rts_dropdown'>
                        <TextField
                            sx={{ width: "20vw" }}
                            inputProps={{ maxLength: 6, emed_tid: 'ip_number' }}
                            size='small'
                            label={t("IP Number")}
                            value={this.state.ip_number}
                            autoComplete='off'
                            emed_tid={"BillNumberTestID01"}
                            onChange={(e) => {
                                let number = CommonValidation.ALPHA_NUM_SPLCHAR(e.target.value);
                                if (number || e.target.value === "") {
                                    this.setState({ ip_number: e.target.value })
                                }
                            }}
                        />
                    </Box>
                </Box>
                <Stack spacing={2} direction="row" alignItems="center" justifyContent="center">
                    <Button variant='outlined' size="small" emed_tid={"getAdvanceAddedDataTestID01"}
                        onClick={() => {
                            if (localGetItem("multiLaboratory") === "true") {
                                this.state.LabData?.forEach((item) => (item["isChecked"] = true))
                            }
                            localSetItem('globalDateFilter', JSON.stringify({FromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'), ToDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'), DateIndex: 1  }))
                            this.setState({
                                patient_name: "",
                                uhid: "",
                                mobile_number: '',
                                ip_number: '',
                                invoice_number: '',
                                fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                                toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                                dateIndex: 1,
                            }, () => this.getAdvanceAddedData())
                        }}
                        id="eMed_Config_btn">{t("Clear")}</Button>
                    <Button variant='contained' size="small" emed_tid={"Search_TestID01"}
                        onClick={() => {
                            localSetItem('globalDateFilter', JSON.stringify({FromDate: this.state.fromDate, ToDate: this.state.toDate, DateIndex: this.state.dateIndex  }))
                            this.getAdvanceAddedData()
                            this.setState({
                                FilterOpen: false
                            })
                        }}
                        id="eMed_Config_btn"  >{t("Search")}</Button>
                </Stack>
            </Box>
        )
    }

    gridToolBar = () => {
        let TextArray = [
            { label: "From Date", value: formatDate(this.state.fromDate) },
            { label: "To Date", value: formatDate(this.state.toDate) },
        ]
        return (
            <Box>
                <CommonGridToolBarWithFilterText FilterTextArray={TextArray} />
            </Box>

        )
    }

    render() {
        const { t } = this.props
        let { advanceAddedData } = this.state;
        const columns = [
            {
                field: "patient_name", headerName: t("Patient Details"), flex: 0.16, density: 'compact',
                renderCell: ({ row }) => (<CommonPatientDetails data={row} disablePhoto={true} />),
                valueGetter: (params) => {
                    const Name = params.row?.patient_name || "";
                    const Mobile = params.row?.patient_mobile_number || "";
                    const UHID = params.row?.patient_uhid || "";
                    return `${Name} ${Mobile} ${UHID}`;
                }
            },
            {
                field: "created_date", headerName: t("Added Date"), flex: 0.10, align: "center", headerAlign: "center", density: 'compact',
                renderCell: ({ row }) => (<Box component={'div'}>{row?.created_date ? row?.created_date : "-"}</Box>)
            },
            {
                field: "invoice_number", headerName: t("Return Bill No"), flex: 0.15, align: "center", headerAlign: "center", density: 'compact',
                renderCell: ({ row }) => (<Box component={'div'}>{row?.invoice_number?.length > 25 ?
                    <Tooltip placement='top' title={row?.invoice_number} arrow><div>{row?.invoice_number.slice(0, 23) + "..."}</div></Tooltip>
                    : row?.invoice_number ? row?.invoice_number : "-"}</Box>)
            },
            {
                field: "ip_number", headerName: t("IP Number"), flex: 0.15, align: "center", headerAlign: "center", density: 'compact',
                renderCell: ({ row }) => (<Box component={'div'}>{row?.ip_number?.length > 25 ?
                    <Tooltip placement='top' title={row?.ip_number} arrow><div>{row?.ip_number.slice(0, 23) + "..."}</div></Tooltip>
                    : row?.ip_number ? row?.ip_number : "-"}</Box>)
            },
            {
                field: "return_advance_amount", headerName: t("Amount"), flex: 0.10, type: "number", density: 'compact',
                renderCell: ({ row }) => (<Box component={'div'}>{row?.return_advance_amount ? AmountFormat(row?.return_advance_amount).replace(`${CurrencySymbol}`, "") : "0.00"}</Box>)
            },
        ]
        const disablePrintExcel = this.state.disableBtn || advanceAddedData?.length === 0;

        return (
            <Box component={'div'} className='eMed_rts_container'>
                <Box component={"div"} className='eMed_Top_Container'>
                    <Box component={"div"} className='eMed_Cards_Container'>
                        {AmountsCard(t("Total Net Amount"), this.state.total_net_amount)}
                    </Box>
                    <Box component={"div"} className='eMed_Action_Container'>
                            <Button className='eMed_usrconf_btn' sx={{ ml: "1vw" }} emed_tid={"eMed_action_img_TestID"} onClick={() => { this.setState({ FilterOpen: true }) }}>
                                <img src={ImagePaths.Filter.default} alt="filter" className='eMed_action_img' />
                            </Button>
                        <Tooltip title="Export" placement='top' arrow disabled={disablePrintExcel}>
                            <Button onClick={() => { this.exportReport() }} className='eMed_usrconf_btn'>
                                <img src={disablePrintExcel ? ImagePaths.ExportIconOff.default : ImagePaths.ExportIcon.default} alt="upload" className='eMed_action_img' />
                            </Button>
                        </Tooltip>
                        {/* <Tooltip title={t("Print")} placement='top' arrow>
                            <Button className='eMed_usrconf_btn' emed_tid={"eMed_usrconf_btn_TestID01"} disabled={this.state.disableBtn} onClick={() => { this.printReports() }}>
                                <img src={ImagePaths.LabPrintIcon.default} alt="print" className='eMed_action_img' />
                            </Button>
                        </Tooltip> */}
                    </Box>
                </Box>
                <Box component={'div'} className='eMed_rts_table'>
                    <DataGrid
                        rows={advanceAddedData}
                        columns={columns}
                        getRowId={(row) => row.sno}
                        page={this.state.page}
                        pageSize={this.state.pageSize}
                        localeText={{
                            toolbarColumns: "",
                            toolbarDensity: "",
                            toolbarExport: "",
                            toolbarFilters: "",
                            toolbarExportPrint: ""
                        }}
                        components={{
                            Toolbar: this.gridToolBar,
                            NoRowsOverlay: () => (
                                <Stack className='eMed_conf_nodata'>
                                    {t("NoRecordsFound")}
                                </Stack>
                            )
                        }}
                        onPageChange={(newPage) => { this.setState({ page: newPage }) }}
                        onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize })}
                        rowsPerPageOptions={[10, 20, 30]}
                        pagination
                        headerHeight={40}
                        disableSelectionOnClick
                    />
                </Box>
                <Drawer
                    anchor={'right'}
                    open={this.state.FilterOpen}
                    ModalProps={{ onBackdropClick: this.closeFilter }}
                >
                    {this.renderFilterScreen()}
                </Drawer>
                {this.state.isErrorMsg ?
                    <ToastMsg
                        severity={'error'}
                        msg={this.state.isErrorMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
                <Loader loaderOpen={this.state.isLoader || this.state.printLoading} forPrint={this.state.printLoading ? true : false} label={this.state.printLoading ? "Building PDF..." : null} />
            </Box>
        )
    }
    closeFilter = () => {
        this.setState({ FilterOpen: false })
    }
}


export default withTranslation()(AdvanceAdded)